module.exports = __webpack_public_path__ + "static/pattern-b0a65a8d1225b544faee538bd71e73d6.svg";